import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { viewDriveItem, DriveItemOrigin, getOrFetchDriveItemMeta, viewableInGallery } from '../../containers/DriveItemList/actions';
import { Api } from '../../typings/api';
import RoutesUtils from '../../utils/routes';
import { DriveItemListOrigin } from '../../containers/DriveItemListPage/constants';

interface HomeProps {
	dispatch: Dispatch<StoreState>;
	welcomePageId?: number;
}

const Home = ({ dispatch, welcomePageId }: HomeProps) => {
	const redirectToWelcomePage = async (welcomePageId: number | undefined): Promise<void> => {
		if (!welcomePageId) {
			redirectToRootFolder();
			return;
		}

		try {
			const welcomePage = await dispatch(getOrFetchDriveItemMeta(welcomePageId)) as Api.DriveItem;

			if (Object.keys(welcomePage).length === 0) { // handle case where driveItem is {}
				redirectToRootFolder();
				return;
			}

			dispatch(viewDriveItem(welcomePage, DriveItemOrigin.List, undefined, true));

			const notRedirected = !viewableInGallery.includes(welcomePage.type);
			if (notRedirected) {
				redirectToRootFolder();
			}
		} catch (error) {
			redirectToRootFolder();
		}
	};

	const redirectToRootFolder = () => {
		RoutesUtils.historyPush(RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, null));
	};

	React.useEffect(() => {
		redirectToWelcomePage(welcomePageId);
	}, [welcomePageId]);

	return null;
};

export default Home;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Home/index.ts